import axios from 'axios'
import { env, EnvType } from '../env'
import { Headers, makeUrl, Params, replaceUrlParams } from './utils'

const {
  facadeBaseUrl, getUser, getMember, getSession, getPolicy, getQuote,
  getSessionByUsername, getEventsByUsername, getQuotesByUsername, getPoliciesByUsername
}: EnvType = env


export const getOne = (headers: Headers) => 
  (resource: string, params: Params) => {
    const { id } = params
    
    let handleResp = (resp: any) => {
      return {
        data: resp.data['data']
      }
    }
    let url = ''

    switch (resource) {
      case 'employees': {
        url = `${facadeBaseUrl}/${replaceUrlParams(getUser, { username: id })}`;
        handleResp = (resp: any) => {
            // Make sure that employees has the id it's looking for
            resp.data['data']['id'] = resp.data['data']['Username']
            return {
                data: resp.data['data']
            }
        }
        break;
      }
      case 'gilders': {
        const getEventsUrl = makeUrl(facadeBaseUrl, `${getEventsByUsername}?user_id=${id}`)
        const getMemberUrl = makeUrl(facadeBaseUrl, replaceUrlParams(getMember, { username: id }))
        const getSessionsUrl = makeUrl(facadeBaseUrl, replaceUrlParams(getSessionByUsername, { username: id }))
        const getPoliciesUrl = makeUrl(facadeBaseUrl, replaceUrlParams(getPoliciesByUsername, { username: id }))
        const getQuotesUrl = makeUrl(facadeBaseUrl, replaceUrlParams(getQuotesByUsername, { username: id }))

        /* TODO Kind of goofy response destructuring,
          but will have to re-examine all endpoints to standardize */
        const returnData = (resp: any) => {
          return resp.data['data']
        }

        const returnEventsData = (resp: any) => {
          return resp.data
        }

        const returnSessionData = (resp: any) => {
          const { data } = resp.data
          data.sort((a: any, b: any) => a['ts'] - b['ts'])
          return data.reverse()  // Return in DESC order
        }
  
        return Promise.allSettled([
          axios.get(getEventsUrl, { headers })
            .then(returnEventsData),
          axios.get(getMemberUrl, { headers })
            .then(returnData),
          axios.get(getPoliciesUrl, { headers })
            .then(returnData),
          axios.get(getQuotesUrl, { headers })
            .then(returnData),
          axios.get(getSessionsUrl, { headers })
            .then(returnSessionData)
        ]).then((result: any[]) => {
          const [events, member, policies, quotes, sessions] = result
          const d = {
            data: {
              ...member.value,
              id: member.value['sub'],
              sessions: sessions.value,
              events: events.value,
              policies: policies.value,
              quotes: quotes.value
            }
          }
          console.log('data', d)
          return d
        })
      }
      case 'policies': {
        url = makeUrl(facadeBaseUrl, replaceUrlParams(getPolicy, { file_id: id }))
        break;
      }
      case 'quotes': {
        url = makeUrl(facadeBaseUrl, replaceUrlParams(getQuote, { file_id: id }))
        handleResp = (resp: any) => {
            console.log('quotes.resp', resp)
            // Yearly Premium's are stored in cents. Need to display as dollars
            const yearlyPremium = resp.data.data.yearly_premium
            if(yearlyPremium) {
                const yearlyPremiumInCents = resp.data.data.yearly_premium / 100
                resp.data.data.yearly_premium = yearlyPremiumInCents.toString()
            }
            return resp.data
        }
        break;
      }
      case 'partners':
      case 'sessions': {
        url = makeUrl(facadeBaseUrl, replaceUrlParams(getSession, { session: id }))
        handleResp = (resp: any) => {
          const data = resp.data['data']
          if (!Array.isArray(data) || data.length === 0) {
            console.error('sessions getOne: empty or invalid data', resp)
            return { data: { id, session: id, uid: '', answers: [] } }
          }
          // Prefer the session_code row, but fall back to any row that has uid/session
          // (older sessions may not have a session_code row saved)
          const start =
            data.find((r: any) => r['key'] === 'session_code') ||
            data.find((r: any) => r && r['uid'] && r['session']) ||
            {}
          const answers = data.filter((r: any) => r['key'] !== '_sparse-index')
          // The route `id` (from getList) is already the canonical DynamoDB PK.
          // Don't reconstruct it from start: the flow API's reprocess_session strips
          // the first '_'-segment off `session`, so `${uid}_${session}` doubles the
          // '__anon__' prefix for anon sessions (e.g. __anon____anon___<uuid>). That
          // mismatches the requested id and makes react-admin's Show render nothing on
          // direct load. Echo the requested id back instead.
          return {
            data: {
              ...start,
              id,
              session: start['session'] || id,
              uid: start['uid'] || '',
              answers,
            },
          }
        }
        break;
      }
    }

    return axios.get(url, { headers })
      .then(handleResp)
      .catch(res => {
        console.error('Error in axios request')
        console.log(res)
      })
  }